import { Badge, Skeleton } from '@mantine/core';
import { useEffect } from 'react';
import { useRuntimeStore } from '../state/runtime-store';
import { runtimeInfoModelLabel } from '../utils/generation-models';

export function RuntimeInfoChip() {
  const runtimeInfo = useRuntimeStore((s) => s.runtimeInfo);
  const refresh = useRuntimeStore((s) => s.refresh);

  useEffect(() => {
    if (!useRuntimeStore.getState().runtimeInfo) {
      void refresh();
    }

    const interval = setInterval(() => {
      void refresh();
    }, 30_000);

    return () => {
      clearInterval(interval);
    };
  }, [refresh]);

  if (!runtimeInfo) {
    return (
      <Skeleton
        height={24}
        radius="xl"
        style={{ width: 180, maxWidth: '100%' }}
        data-testid="runtime-info-chip-skeleton"
      />
    );
  }

  const cap = runtimeInfo.maxJobs === null ? '∞' : String(runtimeInfo.maxJobs);
  const label = `${runtimeInfoModelLabel(runtimeInfo)} / active ${runtimeInfo.activeJobs}/${cap}`;

  return (
    <Badge
      size="sm"
      variant="light"
      color="accent"
      data-testid="runtime-info-chip"
      styles={{
        root: { maxWidth: '100%', width: 'max-content' },
        label: { whiteSpace: 'nowrap' },
      }}
    >
      {label}
    </Badge>
  );
}
